module.exports = __webpack_public_path__ + "media/images/how-it-works/directduel/step-3-df5adcaf23d76b27eefecc2d5455e622.png";